// src/components/Leadership/Leadership.js
import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { BsCheckCircle, BsGraphUp } from 'react-icons/bs'; 
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Management.css';

// Import Images
import person1 from "../../assets/Home/img1.png"; // Mr. P Sriram
import person2 from "../../assets/Home/img2.png"; // Mr. P Janakiram

const Leadership = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="leadership-section" id="leadership">
      <Container>
        <Row className="align-items-center">
          
          {/* LEFT SIDE: IMAGES (Side by Side Grid) */}
          <Col lg={6} md={12} className="mb-4 mb-lg-0">
            <div className="leaders-grid-wrapper" data-aos="fade-right">
              
              {/* CARD 1: Mr. P Sriram */}
              <div className="leader-card-single">
                <div className="leader-img-container">
                  <img src={person1} alt="Mr. P Sriram" className="leader-img" />
                </div>
                {/* Info Box - Half in Half out */}
                <div className="leader-info-box">
                  <span className="leader-name">Mr. P Sriram</span>
                  <span className="leader-role">Managing Director</span>
                  <span className="leader-exp">35+ <span className="leader-expname"> Years of Experience </span> </span>
                </div>
              </div>

              {/* CARD 2: Mr. P Janakiram */}
              <div className="leader-card-single"> 
                {/* Added margin-top to create that "stepped" look like the design if desired, or remove for even alignment */}
                <div className="leader-img-container">
                  <img src={person2} alt="Mr. P Janakiram" className="leader-img" />
                </div>
                {/* Info Box */}
                <div className="leader-info-box">
                  <span className="leader-name">Mr. P Janakiram</span>
                  <span className="leader-role">Director</span>
                  <span className="leader-exp">30+ <span className="leader-expname"> Years of Experience </span> </span>
                </div>
              </div>

            </div>
          </Col>

          {/* RIGHT SIDE: CONTENT */}
          <Col lg={6} md={12}>
            <div className="ps-lg-5" data-aos="fade-left">
              <span className="profile-label">Management Profile</span>
              <h2 className="profile-heading">
                Experienced Leadership Driving<br />
                Manufacturing Excellence
              </h2>
              
              <p className="profile-desc">
                Our leadership team brings decades of hands-on experience in 
                precision manufacturing and automotive components. With a strong 
                focus on quality, process excellence, and customer requirements, 
                they guide our operations to deliver consistent, reliable results 
                for OEMs and Tier-1 partners.
              </p>

              {/* Feature Boxes */}
              <Row className="mb-4 g-3">
                <Col sm={6}>
                  <div className="feature-box">
                    <BsGraphUp className="feature-icon" />
                    <span className="feature-text">
                      Decades of Automotive Manufacturing Experience
                    </span>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="feature-box">
                    <BsCheckCircle className="feature-icon" />
                    <span className="feature-text">
                      Strong Focus on Quality, Process & Delivery
                    </span>
                  </div>
                </Col>
              </Row>

              {/* CTA Button */}
              <Button className="btn-orange-pill">
                Learn More About Our Leadership
              </Button>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default Leadership;